export default __webpack_public_path__ + "static/focus-8ceb3198c880ff3e834f45809438920c.png";